import { AiAdminSidebarDefinition } from 'app/modules/sidebar/models';
import {
  U21CopyButton,
  U21TextField,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { U21SideMenu } from 'app/shared/u21-ui/components/dashboard';
import styled from 'styled-components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AI_ADMIN_INFO_MAP } from 'app/modules/aiAdmin/constants';
import { selectLocalTableConfig } from 'app/modules/localTableSettings/selectors';

const SIDEBAR_ONLY_FIELDS: { key: string; label: string }[] = [
  { key: 'prompt_template', label: 'Prompt template' },
  { key: 'prompt_variables', label: 'Prompt variables' },
  { key: 'raw_prompt', label: 'Raw prompt' },
  { key: 'raw_response', label: 'Raw response' },
  { key: 'processed_response', label: 'Processed response' },
  { key: 'error_message', label: 'Error message' },
  { key: 'feedback', label: 'Feedback' },
  { key: 'meta', label: 'Meta' },
];

interface OwnProps {
  data: AiAdminSidebarDefinition['data'];
}

export const SidebarAiAdmin = ({ data }: OwnProps) => {
  const { icon, localTableConfigType, title } =
    AI_ADMIN_INFO_MAP[data.contentType];
  const localColumns = useSelector(
    selectLocalTableConfig(localTableConfigType),
  );
  const fields = useMemo(
    () => [
      ...localColumns
        .filter((c) => !c.hidden)
        .map((c) => ({ key: c.key, label: c.label })),
      ...SIDEBAR_ONLY_FIELDS,
    ],
    [localColumns],
  );
  return (
    <U21SideMenu title={title} titleIcon={icon}>
      {fields.map(({ key, label }) => {
        const raw = data.content[key];
        const value = typeof raw === 'object' ? JSON.stringify(raw) : raw;
        return (
          <div key={key}>
            <StyledTitleBar>
              <U21Typography variant="subtitle2">{label}</U21Typography>
              <U21CopyButton text={value} />
            </StyledTitleBar>
            <U21TextField
              type="textarea"
              disabled
              onChange={() => {}}
              value={value}
            />
          </div>
        );
      })}
    </U21SideMenu>
  );
};

const StyledTitleBar = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  margin-top: 8px;
`;
